module.exports = __webpack_public_path__ + "static/paralelos-0b36873f75a2fb16bc5ee55b33518355.png";